import React from "react";

export function CustomizationWidgetPreview({ customization, styles }) {
  return (
    <div style={styles.previewWrapper}>
      <h3 style={styles.previewTitle}>Prévia do widget</h3>
      <p style={styles.previewHint}>Alterações aparecem aqui em tempo real</p>
      <div style={styles.previewFrame}>
        <div
          style={{
            ...styles.previewHeader,
            backgroundColor: customization.colors?.primary || "#007bff",
          }}
        >
          <div style={styles.previewHeaderContent}>
            <div style={styles.previewAvatar}>
              {customization.favicon ? (
                <img
                  src={customization.favicon}
                  alt=""
                  style={styles.previewAvatarImg}
                  onError={(e) => {
                    e.target.style.display = "none";
                    const s = e.target.nextElementSibling;
                    if (s) s.style.display = "block";
                  }}
                />
              ) : null}
              <span
                style={{
                  ...styles.previewAvatarEmoji,
                  display: customization.favicon ? "none" : "block",
                }}
              >
                🤖
              </span>
            </div>
            <div style={styles.previewHeaderText}>
              <div style={styles.previewHeaderTitle}>
                {customization.headerText || "Chat do Neurobot"}
              </div>
              <div style={styles.previewHeaderSubtitle}>Online</div>
            </div>
          </div>
        </div>
        <div style={styles.previewMessages}>
          <div style={styles.previewMessageRow}>
            <div
              style={{
                ...styles.previewBubble,
                ...styles.previewBubbleBot,
                backgroundColor: customization.colors?.botBubble || "#e9ecef",
              }}
            >
              {customization.welcomeMessage || "Olá! Como posso ajudar?"}
            </div>
          </div>
          <div style={{ ...styles.previewMessageRow, justifyContent: "flex-end" }}>
            <div
              style={{
                ...styles.previewBubble,
                ...styles.previewBubbleUser,
                backgroundColor: customization.colors?.userBubble || "#007BFF",
              }}
            >
              Exemplo de mensagem
            </div>
          </div>
        </div>
        {customization.footerText ? (
          <div style={styles.previewFooter}>{customization.footerText}</div>
        ) : null}
        <div style={styles.previewInputRow}>
          <input
            type="text"
            placeholder="Digite sua mensagem..."
            readOnly
            style={styles.previewInput}
          />
          <div
            style={{
              ...styles.previewSendBtn,
              backgroundColor: customization.colors?.secondary || "#ff5a8f",
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <line x1="22" y1="2" x2="11" y2="13" />
              <polygon points="22 2 15 22 11 13 2 9 22 2" />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
}
